/* eslint-disable jsx-a11y/alt-text */
import "./App.css";
import Navbar from "./components/Navbar";
import { HeroSection } from "./components/HeroSection";
import { BriefSection } from "./components/BriefSection";
import { ServicesSection } from "./components/ServicesSection";
import { AboutUs } from "./components/AboutSection";
import { NewClients } from "./components/ClientsSection";
import { Location } from "./components/Location";
import { Footer } from "./components/Footer";
import { Team } from "./components/TeamSection";

function App() {
  return (
    <div className="relative min-h-screen bg-paper text-primary">
      {/* Shared page canvas: engraved folio grid + soft warm vignette */}
      <div className="pointer-events-none fixed inset-0 z-0">
        <div className="folio-grid absolute inset-0 opacity-80" />
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(120% 80% at 50% 0%, rgba(212,161,90,0.08) 0%, rgba(247,242,232,0) 45%, rgba(239,230,212,0.6) 100%)",
          }}
        />
      </div>

      <div className="relative z-10 flex flex-col">
        <Navbar />
        <HeroSection />
        <BriefSection />
        <ServicesSection />
        <AboutUs />
        <NewClients />
        <Team />
        <Location />
        <Footer />
      </div>
    </div>
  );
}

export default App;
